@if(Object.keys(matchesByWeek()).length > 0) {
  @for (week of (matchesByWeek() | keyvalue: preserveOrder); track week.key) {
    <div class="week-section">
      <!-- Header de la semaine -->
      <div class="week-header">
        <span class="week-label">{{ formatDate(week.key, 'dd-MM-yyyy') }}</span>
      </div>

      <!-- Version Desktop -->
      <div class="desktop-view">
        <div class="table-header">
          <div class="header-cell logo-col"></div>
          <div class="header-cell home">{{ 'common.home' | translate }}</div>
          <div class="header-cell score">SCORE</div>
          <div class="header-cell logo-col"></div>
          <div class="header-cell away">{{ 'common.away' | translate }}</div>
        </div>

        <div class="matches-list">
          @for (game of getGames(week.value) | keyvalue; track game.key; let indexGame = $index) {
            @for (match of getMatches(game.value); track match.match_id; let indexMatch = $index) {
              <div class="match-row" [class.separator]="indexMatch == 0 && indexGame !== 0">
                <div class="cell logo-cell">
                  <img class="team-logo"
                       [src]="utils.teamImageUrl(null, match.team_id_1, match.team_1_has_profile_picture)"
                       [alt]="match.team_1_name"/>
                </div>
                <div class="cell team-cell"
                     [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1)">
                  <span class="team-name">{{ match.team_1_name }}</span>
                </div>
                <div class="cell score-cell">
                  <div class="score-badge">
                    <span>{{ match.team_1_score }} - {{ match.team_2_score }}</span>
                  </div>
                  @if(match.has_screenshot) {
                    <div class="screenshots-button ml-5">
                      <nb-icon class="pointer" (click)="openScreenshotsGallery(match)" icon="camera-outline" nbPopover="Display screenshots" nbPopoverTrigger="hover" status="warning"></nb-icon>
                    </div>
                  }
                </div>
                <div class="cell logo-cell">
                  <img class="team-logo"
                       [src]="utils.teamImageUrl(null, match.team_id_2, match.team_2_has_profile_picture)"
                       [alt]="match.team_2_name"/>
                </div>
                <div class="cell team-cell away"
                     [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_2)">
                  <span class="team-name">{{ match.team_2_name }}</span>
                </div>
              </div>
            }
          }
        </div>
      </div>

      <!-- Version Mobile -->
      <div class="mobile-view">
        @for (game of getGames(week.value) | keyvalue; track game.key; let indexGame = $index) {
          @for (match of getMatches(game.value); track match.match_id; let indexMatch = $index) {
            <div class="match-card" [class.separator-top]="indexMatch == 0 && indexGame !== 0">
              <div class="team-section home">
                <img class="team-logo"
                     [src]="utils.teamImageUrl(null, match.team_id_1, match.team_1_has_profile_picture)"
                     [alt]="match.team_1_name"/>
                <div class="team-info">
                  <span class="team-label">{{ 'common.home' | translate }}</span>
                  <span class="team-name"
                        [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_1)">
                    {{ match.team_1_name }}
                  </span>
                </div>
              </div>

              <div class="score-section">
                <div class="score-badge">
                  <span>{{ match.team_1_score }} - {{ match.team_2_score }}</span>
                </div>
                @if(match.has_screenshot) {
                  <div class="screenshots-button ml-5">
                    <nb-icon class="pointer" (click)="openScreenshotsGallery(match)" icon="camera-outline" nbPopover="Display screenshots" nbPopoverTrigger="hover" status="warning"></nb-icon>
                  </div>
                }
              </div>

              <div class="team-section away">
                <div class="team-info text-right">
                  <span class="team-label">{{ 'common.away' | translate }}</span>
                  <span class="team-name"
                        [class.current-team]="teamsService.isUserTeam(this.currentUserTeamIds, match.team_id_2)">
                    {{ match.team_2_name }}
                  </span>
                </div>
                <img class="team-logo"
                     [src]="utils.teamImageUrl(null, match.team_id_2, match.team_2_has_profile_picture)"
                     [alt]="match.team_2_name"/>
              </div>
            </div>
          }
        }
      </div>
    </div>
  }
}
@else {
  <div class="no-data">
    <div class="no-data-icon">🏆</div>
    <p>{{ 'games.match_board.no_match' | translate }}</p>
  </div>
}
